import 'reflect-metadata';
import { Expose, plainToInstance, instanceToPlain } from 'class-transformer';

export class Address {
  id: number;

  @Expose({ name: 'first_name' })
  firstName: string;

  @Expose({ name: 'last_name' })
  lastName?: string;

  company?: string;

  @Expose({ name: 'address_1' })
  address1: string;

  @Expose({ name: 'address_2' })
  address2?: string;

  city?: string;

  postcode: string;

  email?: string;

  phone?: string;

  @Expose({ name: 'country_id' })
  countryId: number;

  @Expose({ name: 'zone_id' })
  zoneId?: number;

  @Expose({ name: 'country_name' })
  countryName?: string;

  @Expose({ name: 'zone_name' })
  zoneName?: string;

  @Expose({ name: 'store_address_id' })
  storeAddressId?: number;

  constructor(
    id: number,
    firstName: string,
    address1: string,
    postcode: string,
    countryId: number,
    countryName: string,
    lastName?: string,
    company?: string,
    address2?: string,
    city?: string,
    email?: string,
    phone?: string,
    zoneId?: number,
    zoneName?: string,
    storeAddressId?: number
  ) {
    this.id = id;
    this.firstName = firstName;
    this.lastName = lastName;
    this.company = company;
    this.address1 = address1;
    this.address2 = address2;
    this.city = city;
    this.postcode = postcode;
    this.email = email;
    this.phone = phone;
    this.countryId = countryId;
    this.zoneId = zoneId;
    this.countryName = countryName;
    this.zoneName = zoneName;
    this.storeAddressId = storeAddressId;
  }

  static fromJson(json: Record<string, any>): Address {
    return plainToInstance(Address, json);
  }

  toJson(): any {
    return instanceToPlain(this);
  }
}
